import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { v4 } from 'uuid';
import { propBool, propStr } from '../../../helpers/custom-prop-types';
class SvgImage extends Component {
    constructor(props) {
        super(props);
        this.getFilter = () => {
            const { isBlur, isDisabledGrayScale, isGrayScale } = this.props;
            const filter = `url(#${this.imageId})`;
            return isBlur || (isGrayScale && !isDisabledGrayScale) ? filter : null;
        };
        this.imageId = v4();
        this.state = {
            src: props.src,
        };
    }
    shouldComponentUpdate(nextProps) {
        const { src } = this.props;
        if (src !== nextProps.src) {
            this.setState({ src: nextProps.src });
            return false;
        }
        return true;
    }
    render() {
        const { className, isBlur, isGrayScale, isObjectFit, isObjectFitContain } = this.props;
        let preserveAspectRatio;
        if (isObjectFit) {
            preserveAspectRatio = 'xMidYMid slice';
        }
        else if (isObjectFitContain) {
            preserveAspectRatio = 'xMidYMid meet';
        }
        const { src } = this.state;
        const filter = this.getFilter();
        return (_jsx(LazyLoadComponent, { children: _jsxs("svg", Object.assign({ className: `svg-image ${className}`, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave }, { children: [_jsx("defs", { children: _jsxs("filter", Object.assign({ id: this.imageId }, { children: [isBlur && (_jsx("feGaussianBlur", { in: 'SourceGraphic', stdDeviation: '6' })), isGrayScale && (_jsx("feColorMatrix", { type: 'matrix', values: '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0' }))] })) }), _jsx("image", { 
                        // eslint-disable-next-line react/no-unknown-property
                        externalResourcesRequired: 'true', filter: filter, height: '100%', preserveAspectRatio: preserveAspectRatio || 'xMidYMid slice', width: '100%', x: '0', xlinkHref: src, y: '0' })] }), src) }));
    }
}
SvgImage.propTypes = {
    className: propStr(),
    isBlur: propBool(),
    isDisabledGrayScale: propBool(),
    isGrayScale: propBool(),
    isObjectFit: propBool(),
    isObjectFitContain: propBool(),
    src: propStr().isRequired,
};
SvgImage.defaultProps = {
    className: '',
    isBlur: false,
    isDisabledGrayScale: false,
    isGrayScale: false,
    isObjectFit: false,
    isObjectFitContain: false,
};
export default SvgImage;
